<template>
    <component :is="component">
        <slot/>
    </component>
</template>

<style>
    @font-face {
        font-family: 'regularFont';
        src: url('./assets/fonts/neris-light.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldFont';
        src: url('./assets/fonts/neris-black.otf') format('opentype');
        font-weight: bold;
    }

    html {
        overflow: hidden !important;
    }

    .application {
        font-family: regularFont;
        background: transparent !important;
        font-size: 14px;
    }

    .container {
        padding: 20px !important;
        height: 100%;
    }

    a {
        text-decoration: underline;
    }

    .swal2-container {
        font-family: regularFont;
    }

    .list-separator>span:not(:last-child)::after {
        content: '|';
    }

    .list-separator>span:not(:last-child) {
        margin-right: 5px;
    }

    .dialog-container-body-filter-min {
        border: 1px solid #ccc;
        width: 60px;
        border-radius: 4px;
        margin: 0 auto;
    }

    .dialog-container-body-filter-min input {
        text-align: center;
    }

    .dialog-card-content {
        padding-top: 0;
        padding-bottom: 30px;
    }

    .app-error-info {
        font-size: 14px;
        color: #888;
        text-align: center;
        padding: 20px;
    }

    .app-error-info>div {
        margin-top: 5px;
    }

    .loading-text {
        position: relative;
        display: inline-block;
        font-size: 10px;
        width: 20px;
        height: 20px;
        color: #0696c7;
    }

    .loading-text::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 13px;
        height: 13px;
        margin-top: -10px;
        margin-left: -14px;
        border: 2px solid #0696c7;
        border-top-color: transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>

<script>
    window.appVersion = '2024-12-12 12:20'

    import VuebaseLayout from './layouts/VuebaseLayout'
    import Utils from './services/Utils'
    import mqtt from 'mqtt'

    export default {
        name: 'App',
        components: {
            VuebaseLayout
        },
        computed: {
            component() {
                return VuebaseLayout
            }
        },
        data() {
            return {
                enableSockets: false
            }
        },
        beforeMount: function () {
            Utils.initialize()
            this.enableSockets = window.ptSocketsAvailable
            this.handleSockets()
        },
        methods: {
            handleSockets: function () {
                window.socketsEnabled = false

                if (!this.enableSockets) {
                    return false
                }

                try {
                    window.mqttClient = mqtt.connect('wss://mqtt.mkgest.com:8083')

                    window.mqttClient.on('connect', () => {
                        console.log('MQTT client connected')
                        window.socketsEnabled = true
                    })

                    window.mqttClient.on('error', (err) => {
                        console.log('MQTT client error:', err)
                    })

                    window.mqttClient.on('close', () => {
                        console.log('MQTT client closed')
                    })

                    window.mqttClient.on('reconnect', () => {
                        console.log('MQTT client reconnected')
                        const evt = new CustomEvent('socket-refresh-chat')
                        document.body.dispatchEvent(evt)
                    })

                    window.mqttClient.on('message', (topic, message) => {
                        try {
                            if (topic === 'chat/1' && window.apiDev) {
                                console.log('### MQTT SOCKET IGNORED ###')
                                return false
                            }
                            let jsonData = String.fromCharCode(...message)
                            const isBase64 = jsonData.indexOf('{"id":') === -1 ? true : false
                            if (isBase64) {
                                jsonData = atob(jsonData)
                            }
                            const byteArray = new Uint8Array(jsonData.length)
                            for (let i = 0; i < jsonData.length; i++) {
                                byteArray[i] = jsonData.charCodeAt(i)
                            }
                            const decoder = new TextDecoder('utf-8')
                            jsonData = decoder.decode(byteArray)
                            jsonData = JSON.parse(jsonData)
                            window.postMessage(JSON.stringify({
                                event: 'chat-notification',
                                data: jsonData
                            }), '*')
                        } catch (error) {
                            console.log(error)
                        }
                    })
                } catch (error) {
                    console.log(error)
                }
            }
        }
    }
</script>
